export default __webpack_public_path__ + "static/media/flag-aland-islands.d2ef30c8.svg";